export const LANGS = [
  {
    id: '0',
    label: 'RU',
    textToDoList: 'Список Дел',
    textMoreToDo: ` осталось, `,
    textDone: ' готово',
    typeToSearch: 'поиск дел',
    textNewItem: 'Добавить',
    textTypeToSearch: 'начните вводить',
    textFilterAll: 'Все',
    textFilterActive: 'Активно',
    textFilterDone: 'Готово',
    textAddItemInput: 'что нужно сделать',
  },

  {
    id: '1',
    label: 'EN',
    textToDoList: 'ToDo List',
    textMoreToDo: ' more to do, ',
    textDone: ' done',
    typeToSearch: 'type to searchs',
    textNewItem: 'Add Item',
    textTypeToSearch: 'type to search',
    textFilterAll: 'All',
    textFilterActive: 'Active',
    textFilterDone: 'Done',
    textAddItemInput: 'what needs to be done',
  },
]